import IconSparkle from 'src/icons/IconSparkle'

import ExtractedFieldRow from './ExtractedFieldRow'
import type { AiExtractedRow } from './ExtractedFieldRow'

interface ExtractedFieldsPanelProps {
  fields: AiExtractedRow[]
  // field name → value of record in the application/document, for the tooltip.
  actualValues?: Record<string, string | null>
}

// Read-only "AI Extracted" panel rendered inside the document preview popover.
// Lists every field the model pulled off the document. Always shows what was
// extracted, even if a suggestion was rejected — the confidence pill itself
// records the review outcome (applied / rejected).
const ExtractedFieldsPanel = ({
  fields,
  actualValues = {},
}: ExtractedFieldsPanelProps) => {
  if (!fields.length) return null

  return (
    <div className="flex flex-col">
      {/* Fixed header — mirrors MvrFindingsPill: stays above the scroll area
          while the rows scroll. Owns its padding because the popover dropdown
          is rendered with p-0 (same as the AI flag pill). */}
      <div className="flex items-center justify-between border-b border-doubleNickel-gray-100 px-4 pb-2.5 pt-3.5 text-xs font-semibold text-doubleNickel-brand-500">
        <div className="flex items-center gap-1.5">
          <IconSparkle size={12} />
          <span>AI Extracted</span>
        </div>
        <span className="font-normal text-doubleNickel-gray-400">
          {fields.length} {fields.length === 1 ? 'field' : 'fields'}
        </span>
      </div>

      {/* Cap the list height and scroll inside it — matches MvrFindingsPill's
          popover so a doc with many extracted fields doesn't push the dropdown
          past the viewport. Per-row tooltips portal out, so they aren't clipped. */}
      <div className="max-h-80 overflow-y-auto px-4">
        {fields.map((field) => (
          <ExtractedFieldRow
            key={field.field}
            field={field}
            actualValue={actualValues[field.field] ?? null}
          />
        ))}
      </div>
    </div>
  )
}

export default ExtractedFieldsPanel
